/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReasonCode } from '../../models/reason-code';

export interface UpdateReasonCode$Params {
  id: string;
  body: ReasonCode;
}

export function updateReasonCode(
  http: HttpClient,
  rootUrl: string,
  params: UpdateReasonCode$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ReasonCode>> {
  const rb = new RequestBuilder(rootUrl, updateReasonCode.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReasonCode>;
    })
  );
}

updateReasonCode.PATH = '/admin/reason-codes/{id}';
